export enum MapPointStatesEnum {
    default = 1,
    enabled = 2,
    disabled = 3
}